import React from 'react'
import { counterData } from '../data/startup'
import CountUp from 'react-countup'

export default function Counter() {
  return (
    <div className="row" id="counter">
        {counterData.map((item,index)=>{
            return(
                <div className="col-md-3 col-6" key={index}>
                    <div className="counter-box py-4 py-sm-0 text-center">
                        <i className={`h1 ${item.icon}`}></i>
                        <h2 className="mb-0 mt-2"><CountUp end={item.target}/>+</h2>
                        <h6 className="counter-head text-dark">{item.title}</h6>
                    </div>
                </div>
            )
        })}
    </div>
  )
}
